var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_vm._v("Documentos")]),_c('v-divider'),_c('v-data-table',{staticClass:"elevation-1 my-8",attrs:{"headers":_vm.headers,"items":_vm.documents,"items-per-page":-1,"hide-default-footer":"","dense":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }